'use es6';
/* eslint-disable no-shadow */

import SeamlessImmutable from 'seamless-immutable';
import { combineReducers } from 'redux';
import { SITE_SETTINGS_FETCH } from 'DesignData/actions/ActionTypes';

function isFetching(state = false, action) {
  switch (action.type) {
    case SITE_SETTINGS_FETCH:
      {
        const {
          settings,
          error
        } = action;
        return !settings && !error;
      }

    default:
      {
        return state;
      }
  }
}

function fetchError(state = null, action) {
  switch (action.type) {
    case SITE_SETTINGS_FETCH:
      {
        return action.error || null;
      }

    default:
      {
        return state;
      }
  }
}

function settings(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case SITE_SETTINGS_FETCH:
      {
        const {
          settings
        } = action;
        return settings ? state.merge(settings) : state;
      }

    default:
      return state;
  }
}

export default combineReducers({
  isFetching,
  fetchError,
  settings
});